import {lazyAfterLoad} from '../../../utils'


export default lazyAfterLoad(() => import(/* webpackChunkName: "modal" */ './BlurredModal'))
